function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DialogsComponent from '@/components/DialogsComponent.vue';
import WorkEnvironmentsService from '@/services/work_env_service';
import FormResourceRequestComponent from '@/apps/analytic-services/components/FormResourceRequestComponent';
import FormRequestUpdateComponent from '@/apps/analytic-services/components/FormRequestUpdateComponent';
import LineChart from '@/components/LineChart';
import utils from '@/utils/firebase';
import { mapMutations } from 'vuex';
import DragFileComponent from "@/components/DragFileComponent.vue";
import AnalyticService from '@/apps/analytic-services/services/analytic_service.js';
import firebase from 'firebase';
import 'firebase/auth';
import 'firebase/storage';
import tasks from '@/js/tasks';
var firebaseDataOperation = utils.getFirebaseDataOperation();
export default {
  name: 'MyResourcesPage',
  components: {
    FormRequestUpdateComponent: FormRequestUpdateComponent,
    LineChart: LineChart,
    FormResourceRequestComponent: FormResourceRequestComponent,
    DialogsComponent: DialogsComponent,
    DragFileComponent: DragFileComponent
  },
  data: function data() {
    return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
      DIALOG_RESOURCES: "DIALOG_RESOURCES",
      resource_aux: [],
      key_table: 1,
      rol_aux: null,
      arguments2: [],
      new_aux: [],
      resources: [],
      indiceModal: -1
    }, "key_table", null), "type_options", [{
      text: 'Tabla',
      value: 'bigquery.tables'
    }, {
      text: 'Dataset',
      value: 'bigquery.datasets'
    }]), "roles", []), "tipos", {
      "bigquery.tables": "BIGQUERY_TABLE",
      "bigquery_datasets": "BIGQUERY_DATASET"
    }), "all_routes", []), "mlops_projects", []), "mlops_configs", []), "config", ''), "project", ''), "key_aux", null);
  },
  created: function created() {
    var _this = this;
    console.log(this.$router.currentRoute.meta.mode, this.$router.currentRoute.params.request_id);
    this.mode = this.$router.currentRoute.meta.mode;
    var params2 = {
      domain: window.userInfo.domain
    };
    AnalyticService.get_configs(params2).then(function (response) {
      _this.mlops_configs = response.data;
      console.log(response);
    });
    AnalyticService.get_projects(params2).then(function (response) {
      _this.mlops_projects = response.data;
      console.log(response);
    });
    if (this.mode == "view") {
      var params = {
        domain: window.userInfo.domain,
        request_id: this.$router.currentRoute.params.request_id
      };
      AnalyticService.get_request(params).then(function (response) {
        _this.resources = response.data.resources;
        _this.config = response.data.config_id;
        _this.project = response.data.project_id;
        _this.key_aux++;
        console.log(response);
      });
    }
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['setShowLoading'])), {}, {
    addItem: function addItem() {
      this.arguments2.push({});
    },
    downloadFile: function downloadFile(route, name) {
      var params = {
        route: route
      };
      AnalyticService.download_file(params).then(function (response) {
        console.log(response);
        var archivoContenido = response.data.archivo;
        var blob = new Blob([archivoContenido], {
          type: 'application/octet-stream'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
    getschema: function getschema(value) {
      this.resource_aux.schema = value;
    },
    saveRequest: function saveRequest() {
      var _this2 = this;
      if (this.resources.length == 0) {
        return;
      }
      if (!this.$refs.form.validate()) {
        return;
      }
      this.all_routes = [];
      var date = new Date().toISOString().slice(0, 19).replace("T", "").replace(/[-:]/g, "");
      var code = 'S' + date + '-' + Array.from({
        length: 3
      }, function () {
        return String.fromCharCode(65 + Math.floor(Math.random() * 26));
      }).join('');
      var promises = this.resources.map(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(objeto) {
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                if (!objeto.schema) {
                  _context.n = 2;
                  break;
                }
                _context.n = 1;
                return _this2.convertirArchivoAURL(objeto.schema, objeto.name, code);
              case 1:
                objeto.schema_file = _context.v;
              case 2:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
      Promise.all(promises).then(function () {
        console.log("para backend", _this2.resources);
        var params = {
          domain: window.userInfo.domain,
          type: "BIGQUERY",
          resources: _this2.resources,
          applicant: window.userInfo.email,
          code: code,
          all_routes: _this2.all_routes,
          project_id: _this2.project,
          config_id: _this2.config
        };
        console.log("para backend", params);
        AnalyticService.save_request(params).then(function (response) {
          console.log(response);
          if (response.data) {
            tasks.toast.success("Solicitud generada correctamente.");
            _this2.$router.push({
              name: "ml_requests"
            });
          } else {
            tasks.toast.error("No se pudo generar la solicitud. Intente nuevamente.");
          }
        });
      });
    },
    deletefunc: function deletefunc(row) {
      console.log(row);
      this.roles.splice(row, 1);
      console.log(this.roles);
    },
    convertirArchivoAURL: function convertirArchivoAURL(archivo, name, code) {
      var _this3 = this;
      return new Promise(function (resolve, reject) {
        console.log("subida");
        var file = archivo;
        var date = new Date().toISOString().slice(0, 19).replace("T", "").replace(/[-:]/g, "");
        var route = "mlops/" + code + '/' + name + '/' + file.name.split('.').slice(0, -1).join('.') + date;
        var ref = firebase.storage().ref(route);
        var upload = ref.put(file);
        upload.on("state_changed", function progress(snapshot) {
          console.warn(snapshot.bytesTransferred / snapshot.totalBytes * 100);
        }, function error(error) {
          console.error(error);
          reject(error);
        }, function () {
          _this3.all_routes.push(route);
          var aux = {
            "name": file.name,
            "route": route
          };
          resolve(aux);
        });
      });
    },
    addRow: function addRow() {
      this.roles.push(this.rol_aux);
      this.rol_aux = null;
    },
    addItem_pipe: function addItem_pipe() {
      this.resources.push({});
    },
    saveConfig: function saveConfig() {
      if (!this.$refs.formDialog.validate()) {
        return;
      }
      if (this.indiceModal !== -1) {
        this.resource_aux.arguments = this.arguments2;
        this.resource_aux.roles = this.roles;
        this.resources[this.indiceModal] = _objectSpread({}, this.resource_aux);
        console.log("resource", this.resources);
      }
      this.indiceModal = -1;
      this.$refs[this.DIALOG_RESOURCES].onClose();
      this.key_table++;
    },
    openDialog: function openDialog(data, index) {
      this.indiceModal = index;
      console.log(data);
      if (data) {
        this.resource_aux = Object.assign({}, data);
        if (this.resource_aux.arguments) this.arguments2 = this.resource_aux.arguments.slice();else this.arguments2 = [];
        if (this.resource_aux.roles) this.roles = this.resource_aux.roles;else this.roles = [];
      } else {
        this.resource_aux = {};
      }
      this.$refs[this.DIALOG_RESOURCES].onOpen();
    },
    removeItem: function removeItem(data) {
      var record_details = [];
      var index = 0;
      var _iterator = _createForOfIteratorHelper(this.arguments2),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var detail = _step.value;
          if (data.index !== index) {
            record_details.push(detail);
          } else {}
          index += 1;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.arguments2 = record_details;
    },
    removeItem_pipe: function removeItem_pipe(data) {
      console.log("entra funcion", data);
      var record_details = [];
      var index = 0;
      var _iterator2 = _createForOfIteratorHelper(this.resources),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var detail = _step2.value;
          if (data !== index) {
            record_details.push(detail);
          } else {}
          index += 1;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      this.resources = record_details;
    }
  }),
  computed: {
    headers: function headers() {
      return [{
        text: this.translate('table_my_work_envs.notebook'),
        value: 'instance_name'
      }, {
        text: this.translate('table_my_work_envs.project_gcp'),
        value: 'pr_name'
      }, {
        text: this.translate('table_my_work_envs.link'),
        value: 'notebook_url'
      }, {
        text: this.translate('table_my_work_envs.status'),
        value: 'status'
      }, {
        text: this.translate('table_my_work_envs.actions'),
        value: 'actions'
      }];
    },
    headers_arguments: function headers_arguments() {
      return [{
        text: "Nombre",
        value: 'name'
      }, {
        text: "Descripción",
        value: 'description'
      }, {
        value: 'actions',
        sortable: false
      }];
    },
    headers_tabla: function headers_tabla() {
      return [{
        text: "Nombre",
        value: 'name'
      }, {
        text: "Version",
        value: 'version'
      }, {
        value: 'actions',
        text: "Acciones",
        sortable: false
      }];
    },
    instanceUrl: function instanceUrl() {
      return function (instance) {
        return "https://".concat(instance.notebook_url);
      };
    },
    statusColor: function statusColor() {
      return function (instance) {
        var status = instance.status;
        return status === 'ACTIVE' ? 'green' : status === 'STOPPED' ? 'red' : 'info';
      };
    },
    breadcrumbs: function breadcrumbs() {
      return [{
        text: this.traductor('titles.ml_requests'),
        disabled: false,
        href: '/#/ml/requests'
      }, {
        text: this.mode == "view" ? "Ver solicitud" : "Crear solicitud recurso Bigquery",
        disabled: true
      }];
    }
  }
};